module.exports = __webpack_public_path__ + "static/media/Laugo_14.cf0500ee.jpg";